import styled from "styled-components";
import { OverlayWrapper } from "common/Overlays/Overlay";
import LongPress from "common/Gustures/LongPress.tsx";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import {
  HTMLAttributes,
  PropsWithChildren,
  DetailedHTMLProps,
  forwardRef,
} from "react";
import { BOTTOM_NAVIGATOR } from "common/constants.ts";

interface CardProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onLongPress?: () => void;
}

const Card = forwardRef(
  (
    { onLongPress, children, ...props }: PropsWithChildren<CardProps>,
    ref: any
  ) => {
    const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
    const card = (
      <StyledCard {...props} ref={ref}>
        {children}
      </StyledCard>
    );

    if (!!onLongPress && isBottomNavigator) {
      return <LongPress triggerElement={card} onLongPress={onLongPress} />;
    }

    return card;
  }
);

export default Card;

const StyledCard = styled.div`
  padding: 16px;
  box-shadow: ${(p) => p.theme.shadows.card};
  background-color: ${(p) => p.theme.colors.cardBgColor};
  width: 100%;
  height: auto;
  border-radius: 12px;
  ${OverlayWrapper} {
    background: ${(p) => p.theme.colors.cardBgColor};
  }
  @media (max-width: ${BOTTOM_NAVIGATOR}) {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
`;
